import React from 'react';
import PropTypes from 'prop-types';
import StepWrapper from '../shared-step-sections/step-wrapper';
import StepHeader from '../shared-step-sections/step-header';
import StepContent from "./question-step-content/step-content";
var QuestionStep = function QuestionStep(_ref) {
  var content = _ref.content,
    onNextClick = _ref.onNextClick,
    onUpdatePoints = _ref.onUpdatePoints,
    points = _ref.points,
    score = _ref.score,
    stepsNumber = _ref.stepsNumber,
    currentStepIndex = _ref.currentStepIndex,
    isDesktop = _ref.isDesktop;
  return /*#__PURE__*/React.createElement(StepWrapper, {
    stepClassName: "step--button"
  }, /*#__PURE__*/React.createElement(StepHeader, {
    header: content.StepHeaderTitle,
    currentStep: currentStepIndex,
    totalSteps: stepsNumber
  }), /*#__PURE__*/React.createElement(StepContent, {
    content: content,
    onNextClick: onNextClick,
    onUpdatePoints: onUpdatePoints,
    points: points,
    score: score,
    stepsNumber: stepsNumber,
    currentStepIndex: currentStepIndex,
    isDesktop: isDesktop
  }));
};
QuestionStep.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  content: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  onNextClick: PropTypes.func.isRequired,
  isDesktop: PropTypes.bool.isRequired,
  onUpdatePoints: PropTypes.func.isRequired,
  points: PropTypes.number.isRequired,
  score: PropTypes.number.isRequired,
  stepsNumber: PropTypes.number.isRequired,
  currentStepIndex: PropTypes.number.isRequired
};
export default QuestionStep;